// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__aKZ4P","footer":"ModalError_footer__1o100"};